"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileStatusBadge = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function MapBadgeStatusToLabel(status) {
    var result;
    switch (status) {
        case 'ARCHIVED':
            result = {
                label: 'Archived',
                type: 'secondary',
            };
            break;
        case 'DELETED':
            result = {
                label: 'Deleted',
                type: 'danger',
            };
            break;
        default:
            result = {
                label: 'Active',
                type: 'info-outline',
            };
    }
    return result;
}
function FileStatusBadge(_a) {
    var status = _a.status, _b = _a.size, size = _b === void 0 ? 'small' : _b;
    var _c = MapBadgeStatusToLabel(status), label = _c.label, type = _c.type;
    return (react_1.default.createElement(core_ui_1.Badge, { size: size, type: type }, label));
}
exports.FileStatusBadge = FileStatusBadge;
